/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPhoneNotification = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m11.182 8.752.07.495-3.735 3.736a19.625 19.625 0 0 0 1.968 2.275 19.613 19.613 0 0 0 2.274 1.969l3.737-3.738.495.072 5.808.829v5.626l-.418.298-.582-.814c.54.755.578.81.58.815h-.002l-.003.003-.008.006-.021.014-.066.044c-.053.034-.128.08-.22.13a6.22 6.22 0 0 1-.785.364 7.896 7.896 0 0 1-2.834.508c-2.433 0-5.682-1.025-9.369-4.712-3.687-3.687-4.713-6.936-4.713-9.37 0-1.2.251-2.162.51-2.833.128-.335.26-.6.362-.785.052-.093.096-.166.13-.22l.044-.066.015-.021.008-.012v-.002s.022.014.815.58l-.813-.58.299-.42h5.625zm2.314 9.565c1.582.827 2.917 1.067 3.944 1.067.92 0 1.638-.191 2.116-.375.09-.035.17-.07.243-.103v-2.781l-3.596-.514zM5.734 5.187a5.893 5.893 0 0 0-.376 2.116c0 1.027.241 2.362 1.068 3.943L9.132 8.54l-.514-3.596H5.837a4.624 4.624 0 0 0-.103.243zM19 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPhoneNotification as PhoneNotification };
